import { UsersService } from './user.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class UserGuard  {
  constructor(public auth: UsersService, public router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.auth.isUser()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
